enum baseUrlPath  {
           //test = "https://localhost:44383/api",
          test = "https://www.quizapp.somee.com/api",
    }
    export default baseUrlPath